import type { Identity } from '../types/auth';

/**
 * Who may start or end a maintenance window from the status page.
 *
 * Mirrors the `maintenance_admin` gate in argus-backend (src/auth.ts). Reading
 * the flags needs nothing: the status page shows a window to every viewer,
 * because "down on purpose" is exactly what someone looking at a red server
 * needs to know. Changing one takes the server away from players and blocks
 * its restarts, so it is an explicit node rather than anything a read implies.
 */

export const MAINTENANCE_PERMISSION = 'argus.maintenance';

export function canAdministerMaintenance(identity: Identity | null | undefined): boolean {
  const custom = identity?.raw?.custom;
  const groups = Array.isArray(custom?.groups) ? custom.groups : [];
  if (groups.includes('SPY_Super_admin')) return true;
  const permissions = Array.isArray(custom?.permissions) ? custom.permissions : [];
  return permissions.includes(MAINTENANCE_PERMISSION);
}
